import axios from '@utils/axios-client';
interface ApiResult<T> {
    success: boolean;
    data: T;
}

interface TermsResponse {
    hasAgreed: boolean;
    latestTermsInsertDate: string;
    latestTermsText: string;
}

class TermsAPI {
    prefix = '/api/v1/Terms';

    // 最新の利用規約本文を取得
    async fetchLatestTerms(): Promise<string | null> {
        const url = `${this.prefix}/GetLatest`;
        try {
            const response = await axios.get<{ content: string }>(url);
            return response.data.content;
        } catch (error) {
            return "";
        }
    }

    async agreeTerms(id: string, token?: string): Promise<TermsResponse | null> {
        const url = `${this.prefix}/GetUser`;
        const payload = { userId: id };
        try {
            const response = await axios.post<ApiResult<TermsResponse>>(url, payload, {
                headers: token ? { Authorization: `Bearer ${token}` } : undefined,
            });

            if (response.status === 200 && response.data) {
                return response.data.data;
            } else {
                return null;
            }
        } catch (error) {            
            return null;
        }
    }

    async create(id: string, insertDate: string, jwtToken?: string): Promise<boolean> {
        const url = `${this.prefix}/Create`;
        const payload = { userId: id, termsInsertDate: insertDate };

        try {
            const headers = jwtToken
                ? { Authorization: `Bearer ${jwtToken}` }
                : undefined;

            const response = await axios.post(url, payload, { headers });

            return response.status === 200 && response.data.success;
        } catch (error) {
            return false;
        }
    }
}

export const termsAPI = new TermsAPI();
